import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as reportsActions from '../../actions/Reports';
import { Dropdown, DropdownMenu, DropdownItem } from 'reactstrap';
import LocaleComponent from '../../LocaleComponent';

const Spinner = require('react-spinkit');

class Header extends LocaleComponent {

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
    };
  }

  componentDidMount() {
    document.body.classList.toggle('sidebar-hidden');
    document.body.classList.toggle('sidebar-mobile-show');
    // document.body.classList.toggle('sidebar-minimized');
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-minimized');
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  }

  selectLocale(locale) {
    this.props.selectLocale(locale);
  }

  render() {
    const {languages, statuses, loading, spin} = this.props;

    const langs = Object.keys(languages).reduce((prev, lang) => {
      prev.push({language: lang, name: languages[lang]});
      return prev;
    }, []);

    const mcId = this.getMcId() || '';

    return (
      <header className="app-header navbar">
        <button
          className="navbar-toggler mobile-sidebar-toggler d-lg-none"
          type="button"
          onClick={(e) => {if (!this.props.disableSidebar) this.mobileSidebarToggle(e)}}
        >&#9776;</button>
        <a className="navbar-brand" href="#" />
        <ul className="nav navbar-nav d-md-down-none">
          <li className="nav-item">
            <button
              className="nav-link navbar-toggler sidebar-toggler"
              type="button"
              onClick={(e) => {if (!this.props.disableSidebar) this.sidebarToggle(e)}}
            >&#9776;</button>
          </li>
          <li className="nav-item px-3">
            <a className="nav-link" href="#">
              {this.localeMessage('Home')}
            </a>
          </li>
          <li className="nav-item px-3">
            <a className="nav-link" href={`#/report?mcId=${mcId}`}>
              {this.localeMessage('Report')}
            </a>
          </li>
        </ul>
        <ul className="nav navbar-nav ml-auto">
          {(loading || spin) &&
          <li className="nav-item d-md-down-none">
            <Spinner name='circle' />
          </li>}
          <li className="nav-item d-md-down-none" onClick={this.asideToggle}>
            <a className="nav-link" href="#">
              <i className="icon-bell" />
              {statuses.length &&
              <span className="badge badge-pill badge-danger">
                {statuses.length}
              </span>}
            </a>
          </li>
          <li className="nav-item">
            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
              <button onClick={this.toggle}
                      className="nav-link dropdown-toggle"
                      data-toggle="dropdown"
                      type="button"
                      aria-haspopup="true"
                      aria-expanded={this.state.dropdownOpen}>
                <span className="d-md-down-none">
                  <i className="icon-settings icons font-1xl d-block mt-1" />&nbsp;
                  {this.localeMessage('Settings')}
                </span>
              </button>

              <DropdownMenu className="dropdown-menu-right">
                <DropdownItem header className="text-center">
                  <strong>{this.localeMessage('Languages')}</strong>
                </DropdownItem>
                {
                  langs.map((lang) => (
                    <DropdownItem
                      key={lang.language}
                      onClick={() => {this.selectLocale(lang.language)}}>
                      {lang.name}
                    </DropdownItem>
                  ))
                }
              </DropdownMenu>
            </Dropdown>
          </li>
        </ul>
      </header>
    );
  }
}

class HeaderContainer extends Component {
  render() {
    return <Header
      {...this.props}
      {...bindActionCreators({
        ...reportsActions,
      }, this.props.dispatch)} />;
  }
}

HeaderContainer = connect(state => ({
  mcId: state.reports.get('mcId'),
  statuses: state.reports.get('statuses'),
  selectedLocale: state.reports.get('selectedLocale'),
  translations: state.reports.get('translations'),
  languages: state.reports.get('languages'),
  loading: state.reports.get('loading'),
  spin: state.reports.get('spin'),
}))(HeaderContainer);

export default HeaderContainer;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js